import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const ChiefSignup = () => {
  const navigate = useNavigate();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await fetch('/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email, password,
          adminuserid: window.APPSETTING.adminuserid,
          appname:     window.APPSETTING.appname,
        }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Signup failed');

      window.APPUSER = data;
      localStorage.setItem(window.APPSETTING.appname + 'user', JSON.stringify(data));
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="chief-form-wrap">
      <div className="chief-form-card">
        <h2>Create your workspace</h2>
        <p className="form-sub">Set up your AI Chief of Staff</p>

        {error && <div className="chief-form-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="chief-fg">
            <label>Work email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
            />
          </div>
          <div className="chief-fg">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Choose a strong password"
              required
            />
          </div>
          <button
            type="submit"
            className="btn-gold"
            style={{ width: '100%', marginTop: '8px' }}
            disabled={loading}
          >
            {loading ? 'Creating…' : 'Create Workspace →'}
          </button>
        </form>

        <p style={{ marginTop: '20px', fontSize: '0.82rem', color: 'var(--muted)', textAlign: 'center' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: 'var(--gold)' }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default ChiefSignup;
